import { cssRule } from 'typestyle';

cssRule('.tb-thumbnail-admin-insights', {
    width: '250px',
    height: '180px',
});

